"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _tabs = _interopRequireDefault(require("britive-design-system/core/components/tabs"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _MyAllSecrets = _interopRequireDefault(require("./all-secrets/MyAllSecrets"));

var _action = require("./action");

var _action2 = require("../../../../components/page-header/action");

var _action3 = require("../../../../components/spinner-overlay/action");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.secrets-requests-approvals-container {\n  margin-left: 3.5rem; }\n";
  var fileName = "secr_index";
  var element = document.querySelector("style[data-sass-component='secr_index']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var TabPanel = function TabPanel(props) {
  var value = props.value,
      index = props.index;
  return value === index && /*#__PURE__*/_react.default.createElement("div", null, props.children);
};

TabPanel.propTypes = {
  value: _propTypes.default.number,
  index: _propTypes.default.number,
  children: _propTypes.default.any
};

var SecretsRequestsApprovals = function SecretsRequestsApprovals(_ref) {
  var _location;

  var history = _ref.history,
      match = _ref.match;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.vaultLanding;
  }),
      vaultDetailsLoading = _useSelector.loading;

  var tabValues = {
    allSecrets: 0
  };

  var getTabValue = function getTabValue() {
    if (location.pathname.includes('/my-secrets/all-secrets')) {
      return tabValues.allSecrets;
    }
  };

  (0, _react.useEffect)(function () {
    setValue(getTabValue());
  }, [(_location = location) === null || _location === void 0 ? void 0 : _location.pathname]);
  (0, _react.useEffect)(function () {
    dispatch((0, _action2.setPageHeaderAction)(_constants.pageTitle, []));
    dispatch((0, _action.requestVaultLanding)());
  }, []);
  (0, _react.useEffect)(function () {
    dispatch((0, _action3.initSpinnerOverlay)({
      open: vaultDetailsLoading,
      size: 'medium',
      message: _constants.vaultLoadingMessage
    }));
  }, [vaultDetailsLoading]);
  var initialTab = [{
    title: 'All Secrets',
    link: '/all-secrets'
  }];

  var handleChange = function handleChange(index) {
    setValue(index);
    history.push("/my-secrets".concat(initialTab[index].link));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretsRequestsApprovalsContainer
  }, /*#__PURE__*/_react.default.createElement(_tabs.default, {
    value: value,
    handleChange: handleChange,
    items: initialTab,
    variant: "auto"
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "".concat(match.url, "/all-secrets"),
    component: _MyAllSecrets.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    exact: true,
    path: match.url,
    to: "".concat(match.url, "/all-secrets")
  })));
};

SecretsRequestsApprovals.propTypes = {
  history: _propTypes.default.any,
  match: _propTypes.default.any
};
var _default = SecretsRequestsApprovals;
exports.default = _default;